import { useMemo } from 'react';
import * as yup from 'yup';

const useConstraints = () => {
  const loginSchema = useMemo(() => {
    return yup.object().shape({
      username: yup
        .string()
        .required('Laukas negali būti tuščias'),
      password: yup
          .string()
          .required('Laukas negali būti tuščias'),
    });
  }, []);

  return {
    loginSchema,
  };
};

export default useConstraints;
